export function location (state) {
  return state.location
}

export function allLocations (state) {
  return state.all
}

